// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.services-section {
  width: 100%;
  position: relative;
  background-color: #982D67;
  z-index: 2;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
}
.services-section::after {
  content: "";
  width: 100%;
  height: 20px;
  background-color: #F5F5F5;
  position: absolute;
  bottom: -20px;
  z-index: 2;
  left: 0;
}

.services-section-add-box {
  width: 100%;
  height: 400px;
  background-color: green;
  opacity: 0;
  position: relative;
}
@media (max-width: 1050px) {
  .services-section-add-box {
    height: 1000px;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/ServicesSection/ServicesSection.scss","webpack://./src/styles/variables.scss","webpack://./src/styles/mixins.scss"],"names":[],"mappings":"AAGA;EACI,WAAA;EACA,kBAAA;EACA,yBCJS;EDKT,UAAA;EENA,aAAA;EACA,sBFQqB;EEPrB,2BFO6B;EEN7B,uBFMyC;AAD7C;AAYI;EACI,WAAA;EACA,WAAA;EACA,YAAA;EACA,yBCrBW;EDsBX,kBAAA;EACA,aAAA;EACA,UAAA;EACA,OAAA;AAVR;;AAcA;EACI,WAAA;EACA,aAAA;EACA,uBAAA;EACA,UAAA;EACA,kBAAA;AAXJ;AAaI;EAPJ;IAQQ,cAAA;EAVN;AACF","sourcesContent":["@use '../../styles/mixins.scss';\n@import '../../styles/variables.scss';\n\n.services-section {\n    width: 100%;\n    position: relative;\n    background-color: $main-color;\n    z-index: 2;\n    // overflow: hidden;\n    // transition: transform 0.1s ease-in-out;\n    @include mixins.flex(column, flex-start, flex-start);\n\n    // .services-section-container {\n    //     width: 100%;\n    //     overflow: hidden;\n    //     position: relative;\n    //     // height: 100vh;\n    //     // max-height: 703px;\n    //     @include mixins.flex(column, flex-start, flex-start);\n    // }\n\n    &::after {\n        content: '';\n        width: 100%;\n        height: 20px;\n        background-color: $light-background;\n        position: absolute;\n        bottom: calc(-20px);\n        z-index: 2;\n        left: 0;\n    }\n}\n\n.services-section-add-box {\n    width: 100%;\n    height: 400px;\n    background-color: green;\n    opacity: 0;\n    position: relative;\n\n    @media (max-width: 1050px) {\n        height: 1000px;\n    }\n}\n\n","// Colors\n\n$main-color: #982D67;\n$white: #FFFFFF;\n$light-background: #F5F5F5;\n$purple: #812456;\n$grey: #EAEAEA;\n$grey-opacity:#E0E0E0;\n$grey-dark: #575756;\n$grey-text: #BCBCBC;\n$dark: #313130;\n$red: #AE2323;\n$opacity-text: rgba(255, 255, 255, 0.50);","@mixin flex($dir, $jc, $ai) {\n    display: flex;\n    flex-direction: $dir;\n    justify-content: $jc;\n    align-items: $ai;\n}\n\n@mixin font ($font, $size, $style, $weight, $height) {\n    font-family: $font;\n    font-size: $size;\n    font-style: $style;\n    font-weight: $weight;\n    line-height: $height;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
